import * as React from "react";
import { hot } from "react-hot-loader";
import App from "./App";

class HMR extends React.Component<Record<string, unknown>, undefined> {
    public render() {
        return <App />;
    }
}

declare let module: Record<string, unknown>;

export default hot(module)(HMR);
